import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { User, UserDetails } from '../models/user.model';
import { environment } from 'src/environment';
import { PageResult } from '../shared/models/pageResult';
import { DistributionGroup } from '../models/distribution-group.model';

@Injectable({
  providedIn: 'root'
})
export class UsersApiService {
  #httpservice = inject(HttpClient);
  //#baseUrl = inject(ConfigurationService).config.serverUrl;
  #baseUrl = environment.apiUrl;
  #specBaseUrl = `${this.#baseUrl}/user`;
  #globalUrl = `${this.#baseUrl}/global`;
  #specGroupsBaseUrl = `${this.#baseUrl}/distributionGroups`

  getUsers = () => {
    return this.#httpservice.get<User[]>(`${this.#globalUrl}/getUsers`)
  };
  getGroups = () => {
    return this.#httpservice.post<PageResult<DistributionGroup>>(`${this.#specGroupsBaseUrl}/getDistributionGroups`, {})
  };
  getContactsByQuestionnaireId = (id: number) => {
    return this.#httpservice.get<User[]>(`${this.#specBaseUrl}/getRecipients/${id}`)
  };
  getUserDetails = (email: string, name: string) => {
    return this.#httpservice.post<User>(`${this.#specBaseUrl}/getUserDetails`, { email, name })
  };
  getLoggedUserDetails = () => {
    return this.#httpservice.get<UserDetails>(`${this.#globalUrl}/getLoggedUserDetails`)
  };
  getUserRole = (id: number) => {
    return this.#httpservice.get<User>(`${this.#specBaseUrl}/getUserRole/${id}`)
  };
  getAbilityToEditForUser = (id: number) => {
    return this.#httpservice.get<boolean>(`${this.#globalUrl}/getAbilityToEditForUser/${id}`);
  };
}
